import ConfigStyle from 'core/constants/ConfigStyle';

const getNotificationColors = (type: string) => {
  let borderColor;
  let backgroundColor;
  let textColor;
  switch (type) {
    case 'success':
      borderColor = ConfigStyle.colors['success-500'];
      backgroundColor = ConfigStyle.colors['success-50'];
      textColor = ConfigStyle.colors['success-900'];
      break;
    case 'warning':
      borderColor = ConfigStyle.colors['secondary-500'];
      backgroundColor = ConfigStyle.colors['secondary-50'];
      textColor = ConfigStyle.colors['secondary-900'];
      break;
    case 'error':
      borderColor = ConfigStyle.colors['danger-500'];
      backgroundColor = ConfigStyle.colors['danger-50'];
      textColor = ConfigStyle.colors['danger-900'];
      break;
    default:
      borderColor = ConfigStyle.colors['info-500'];
      backgroundColor = ConfigStyle.colors['info-50'];
      textColor = ConfigStyle.colors['info-900'];
  }
  return { borderColor, backgroundColor, textColor };
};

export default getNotificationColors;
